import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import MessageItem from './MessageItem';
import type Message from 'owa-service/lib/contract/Message';

export default observer(function RepliesContainer({ unreadReplies }: { unreadReplies: Message[] }) {
    const replyStyle = {
        body: styles.replyBody,
        preview: styles.replyText,
        unread: styles.unread,
        timeAndPersonaWrapper: styles.timeAndPersonaWrapper,
    };

    return (
        <div className={styles.replyContainer}>
            {unreadReplies.map((reply, index) => {
                return <MessageItem message={reply} messageItemStyle={replyStyle} key={index} />;
            })}
        </div>
    );
});
